import React, { useState, useEffect } from 'react';

import { PlacesProvider } from '../../../dataProvider';
import { TYPES } from '../../../envs';
import Autocomplete from '../../../components/autocomplete';

const setLocation = (location, index) => {
  //   setModuleParameters({
  //     ...moduleParameters,
  //     ...(index === 0 ? { location } : { secondLocation: location }),
  //   });
};
const exclude = [];
export const PlaceSelector = ({
  position,
  regions,
  excludeRegions = exclude,
  type,
  grid,
  onChange,
  lastSelection
}) => {
  const [provinceAutocomplete, setProvinceAutocomplete] = useState('');
  const [regionAutocomplete, setRegionAutocomplete] = useState('');
  const [townAutocomplete, setTownAutocomplete] = useState('');
  const [province, setProvince] = useState('');
  const [region, setRegion] = useState('');
  const [town, setTown] = useState('');

  useEffect(() => {
    onChange({ province, region, town });
  }, [province, region, town]);

  useEffect(() => {
    setTownAutocomplete('');
    setTown('');
    setProvinceAutocomplete('');
    setProvince('');
    setRegionAutocomplete('');
    setRegion('');
  }, [type]);
  // useEffect(() => {
  //   lastSelection(province);
  // }, [province]);
  // useEffect(() => {
  //   lastSelection(region);
  // }, [region]);
  // useEffect(() => {
  //   lastSelection(town);
  // }, [town]);

  return (
    <div className={grid}>
      <div>
        <h3>Selecciona lugar {position}</h3>

        <div className="row">
          <div className="three">
            <h4>Comunidad</h4>
            {type === TYPES.MUNICIPAL ? (
              <div>No disponible para este módulo</div>
            ) : (
              <PlacesProvider
                sortby="name"
                type="REGION"
                excludedGrandParentIds={excludeRegions}
                electionType={type}
              >
                {data => {
                  if (data && data.length) {
                    return (
                      <Autocomplete
                        results={data.filter(d =>
                          regionAutocomplete
                            ? d.name
                                .toLocaleLowerCase()
                                .includes(
                                  regionAutocomplete.toLocaleLowerCase()
                                )
                            : d
                        )}
                        onChange={value => {
                          setRegionAutocomplete(value);
                        }}
                        onSelect={(event, select) => {
                          event.preventDefault();
                          setProvinceAutocomplete('');
                          setProvince('');
                          setTownAutocomplete('');
                          setTown('');
                          lastSelection(select);
                          setRegion(select);
                        }}
                        placeholder="Escribe una comunidad autónoma"
                        showArrow
                        type={type}
                      />
                    );
                  }
                  return null;
                }}
              </PlacesProvider>
            )}
          </div>

          <PlacesProvider
            type="PROVINCE"
            sortby="name"
            excludedGrandParentIds={excludeRegions}
            parentId={region ? region.ineId : ''}
            electionType={type}
          >
            {data => (
              <div className="three">
                <h4>Provincia</h4>
                <Autocomplete
                  results={[
                    ...data.filter(d =>
                      provinceAutocomplete
                        ? d.name
                            .toLocaleLowerCase()
                            .includes(provinceAutocomplete.toLocaleLowerCase())
                        : d
                    )
                  ]}
                  onChange={value => {
                    setProvinceAutocomplete(value);
                  }}
                  onSelect={(event, select) => {
                    event.preventDefault();
                    setTownAutocomplete('');
                    setTown('');
                    lastSelection(select);
                    setProvince(select);
                  }}
                  defaultValue={province ? province.ineId : ''}
                  placeholder="Escribe una provincia"
                  showArrow
                  type={type}
                />
              </div>
            )}
          </PlacesProvider>

          <div className="three">
            <h4>Localidad</h4>
            <PlacesProvider
              type="TOWN"
              sortby="name"
              excludedGrandParentIds={excludeRegions}
              parentId={province ? province.ineId : ''}
              electionType={type}
            >
              {data => (
                <Autocomplete
                  results={[
                    ...data.filter(d =>
                      townAutocomplete
                        ? d.name
                            .toLocaleLowerCase()
                            .includes(townAutocomplete.toLocaleLowerCase())
                        : d
                    )
                  ]}
                  onChange={value => {
                    setTownAutocomplete(value);
                  }}
                  onSelect={(event, select) => {
                    event.preventDefault();
                    lastSelection(select);
                    setTown(select);
                  }}
                  defaultValue={town ? town.ineId : ''}
                  placeholder="Escribe una localidad"
                  showArrow
                  type={type}
                />
              )}
            </PlacesProvider>
          </div>
        </div>
      </div>
    </div>
  );
};
